export const AntennaLogo = ({ className = "h-6 w-6" }) => (
  <img
    src="/antenna_logo.png?v=3"
    alt="NovaStream"
    className={`${className} object-contain`}
    draggable="false"
  />
);
